import React, { Fragment, Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import P from '@deliveroo/consumer-component-library/components/P';
import Button from '@deliveroo/consumer-component-library/components/Button';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import PageContainer from '@deliveroo/consumer-component-library/components/PageContainer';
import TextInput from '@deliveroo/consumer-component-library/components/TextInput';
import AppStoreBadge from '@deliveroo/consumer-component-library/components/AppStoreBadge';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import Header from '../Header';

import { trackClickAppDownload } from '../../actions/tracking/apps';
import { submitArea } from '../../actions/voteAreaActions';
import i18n from '../../utils/i18n';

import localePendingKW from './images/kw.png';
import street from './images/street.svg';
import styles from './styles.scss';

export class MarketLandingPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  handleInputChange(evt) {
    const value = evt.target.value;
    const name = evt.target.name;

    this.setState({
      [name]: value,
    });
  }

  onSubmit(evt) {
    evt.preventDefault();

    const postdata = {
      email: this.state.email,
      coordinates: [null, null],
      // Hack to make coverage endpoint save postcodes for non-postcode countries
      // https://github.com/deliveroo/orderweb/pull/12460
      post_code: '000000',
    };

    this.props.submitArea(postdata);
  }

  renderLandingPage(tld) {
    const { voteArea } = this.props;

    const pageCopy = {
      kw: {
        heading: i18n.gettext('new_market_landing.heading.kw'),
        body: i18n.gettext('new_market_landing.body.kw'),
      },
    };

    return (
      <div className={styles.content}>
        <div className={styles.text}>
          <Heading color="black" level={1} size="large" spacing="0 0 x-large 0">
            {pageCopy[tld].heading} {'\u{1F44B}'}
          </Heading>
          <Heading level={2} size="x-small">
            {i18n.gettext('new_market_landing.subtitle')}
          </Heading>
          <P adjacentVerticalSpacing="small">{pageCopy[tld].body}</P>
        </div>

        <div className={classnames(styles['aside-container'], styles.form)}>
          {voteArea.submitted ? (
            <Fragment>
              <Heading level={2} size="x-small">
                {i18n.gettext('new_market_landing.thanks_heading')}
              </Heading>
              <P spacing="small 0 large 0">{i18n.gettext('new_market_landing.thanks_copy')}</P>
            </Fragment>
          ) : (
            <Fragment>
              <Heading level={2} size="x-small">
                {i18n.gettext('new_market_landing.form_heading')}
              </Heading>
              <P spacing="small 0 large 0">{i18n.gettext('new_market_landing.form_copy')}</P>

              <form onSubmit={this.onSubmit}>
                <TextInput
                  type="email"
                  name="email"
                  value={this.state.email}
                  placeholder={i18n.gettext('Email address')}
                  id="email"
                  onChange={this.handleInputChange}
                  isRequired
                />

                {voteArea.error && (
                  <label htmlFor="email" className={styles.error}>
                    {voteArea.error.message}
                  </label>
                )}

                <Button spacing="large 0 0" shouldSubmit>
                  {i18n.gettext('Send')}
                </Button>
              </form>
            </Fragment>
          )}
        </div>
      </div>
    );
  }

  renderLocalePending(tld) {
    const { onClickAppDownload } = this.props;

    const images = {
      kw: localePendingKW,
    };
    const pageCopy = {
      kw: {
        heading: i18n.gettext('new_market_locale_pending.heading.kw'),
        subheading: i18n.gettext('new_market_locale_pending.subheading.kw'),
        body: i18n.gettext('new_market_locale_pending.body.kw'),
        cta: i18n.gettext('new_market_locale_pending.cta.kw'),
        image: i18n.gettext('new_market_locale_pending.image.kw'),
      },
    };

    return (
      <div className={styles.content}>
        <div className={styles.text}>
          <Heading color="black" level={2} spacing="0 0 small 0">
            {pageCopy[tld].heading}
          </Heading>
          <P>{pageCopy[tld].subheading}</P>
          <Spacer spacing="medium 0">
            <a
              href="/app?platform=ios"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => onClickAppDownload(`Locale pending page: ${tld}`)}
              className={styles.appStoreBadge}
            >
              <AppStoreBadge
                type="ios"
                text={i18n.gettext('Download Deliveroo in the App Store')}
              />
            </a>
            <a
              href="/app?platform=android"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => onClickAppDownload(`Locale pending page: ${tld}`)}
              className={styles.appStoreBadge}
            >
              <AppStoreBadge type="android" text={i18n.gettext('Get Deliveroo on Google Play')} />
            </a>
          </Spacer>
          <hr className={styles.divider} />
          <P adjacentVerticalSpacing="medium">{pageCopy[tld].body}</P>
          <Button adjacentVerticalSpacing="large" href="/en/">
            {pageCopy[tld].cta}
          </Button>
        </div>

        <div className={styles['aside-container']}>
          <img src={images[tld]} alt={pageCopy[tld].image} className={styles.appImage} />
        </div>
      </div>
    );
  }

  renderClosingDownPage(tld) {
    const pageCopy = {
      de: {
        heading: i18n.gettext('germany_shutdown.landing_page.heading'),
        subtitle: i18n.gettext('germany_shutdown.landing_page.subtitle'),
      },
      fallback: {
        heading: '',
        subtitle: '',
      },
    };

    const content = pageCopy[tld] || pageCopy.fallback;

    return (
      <Fragment>
        <div className={classnames(styles.container, styles.closingDownPage)}>
          <Header maxWidth="xx-large" isTransparent />
          <PageContainer>
            <div className={styles.text}>
              <Heading color="black" level={2} spacing="0 0 small 0">
                {content.heading}
              </Heading>
              <P>{content.subtitle}</P>
            </div>
          </PageContainer>
        </div>

        <div className={styles.footer}>
          <PageContainer>
            <img className={styles['footer-image']} alt="restaurant" src={street} />
          </PageContainer>
        </div>
      </Fragment>
    );
  }

  render() {
    const { currentCountry, isBlank, localePending, isClosingDownPage } = this.props;

    if (isBlank) {
      return (
        <div className={styles['blank-container']}>
          <PageContainer>
            <header className={styles.header}>
              <a href="/" className={styles.logo}>
                Deliveroo
              </a>
            </header>
          </PageContainer>
        </div>
      );
    }

    if (isClosingDownPage) {
      return this.renderClosingDownPage(currentCountry.tld);
    }

    return (
      <Fragment>
        <div className={styles.container}>
          <PageContainer>
            <header className={styles.header}>
              <a href="/" className={classnames(styles.logo, styles[`logo-${currentCountry.tld}`])}>
                Deliveroo
              </a>
            </header>

            {localePending
              ? this.renderLocalePending(currentCountry.tld)
              : this.renderLandingPage(currentCountry.tld)}
          </PageContainer>
        </div>

        {!localePending && (
          <div className={styles.footer}>
            <PageContainer>
              <img className={styles['footer-image']} alt="" src={street} />
            </PageContainer>
          </div>
        )}
      </Fragment>
    );
  }
}

MarketLandingPage.propTypes = {
  currentCountry: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  voteArea: PropTypes.shape({
    submitted: PropTypes.bool.isRequired,
    error: PropTypes.object,
  }).isRequired,
  submitArea: PropTypes.func.isRequired,
  isBlank: PropTypes.bool,
  localePending: PropTypes.bool,
  onClickAppDownload: PropTypes.func.isRequired,
  isClosingDownPage: PropTypes.bool,
};

MarketLandingPage.defaultProps = {
  isBlank: false,
  localePending: false,
  isClosingDownPage: false,
};

export default connect(
  (state) => ({
    currentCountry: state.request.country,
    voteArea: {
      submitted: state.voteArea.submitted,
      error: state.voteArea.error,
    },
  }),
  (dispatch) => ({
    submitArea: (areaData) => dispatch(submitArea(areaData)),
    onClickAppDownload: (page) => dispatch(trackClickAppDownload(page)),
  }),
)(MarketLandingPage);
